// Audio
export { createWebAudioPlayer as createAudioPlayer } from "./audio/player.web";
export { createWebAudioRecorder as createAudioRecorder } from "./audio/recorder.web";
export { createWebAudioSynth as createAudioSynth } from "./audio/synth.web";
export type {
  AudioPlayer,
  AudioRecorder,
  AudioSynth,
  ChordPlayOptions,
  NotePlayOptions,
  PlaybackState,
  RecordingResult,
} from "./audio/types";

// File picker
export { createWebFilePicker as createFilePicker } from "./file-picker/picker.web";
export type {
  FilePicker,
  PickedFile,
  PickFileOptions,
  PickResult,
} from "./file-picker/types";

// Storage
export type { KeyValueStorage, StorageType } from "./storage/types";
